import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "~/common/Store/models/RootReadonly";
import { defaultUserObject } from "~/common/Store/rootReducer";
import useIsMounted from "~/common/useIsMounted";
import PlusShipping from "./PlusShipping";
interface Props {
  hasFreeShipping: boolean;
  hasWebPlusDiscountedShipping: boolean;
  isWebstaurantPlusEligible: boolean;
}
const PlusShippingLevels = ({
  hasFreeShipping,
  hasWebPlusDiscountedShipping,
  isWebstaurantPlusEligible
}: Props) => {
  const mounted = useIsMounted();
  const user = useSelector((state: RootState) => mounted ? state.user : defaultUserObject);
  if (isWebstaurantPlusEligible) {
    return <PlusShipping hasWebPlus={!!user.hasWebPlus} text="Ships free with " />;
  }
  if (hasWebPlusDiscountedShipping && !hasFreeShipping) {
    return <PlusShipping hasWebPlus={!!user.hasWebPlus} text="Discounted shipping with " />;
  }
  return null;
};
export default PlusShippingLevels;